














































import Vue, { PropType } from 'vue';
import type { Subscription } from '@/types';

type Data = {
  model: Subscription | null;
  guard: string;
  dialog: boolean;
  error: Error | null;
};

export default Vue.extend({
  props: {
    subscription_id: {
      type: Number as PropType<number>,
      required: true
    }
  },
  data(): Data {
    return {
      model: null,
      dialog: false,
      error: null,
      guard: '@todo'
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.load();
      }
    }
  },
  methods: {
    load() {
      this.$store.api.subscription(this.subscription_id).then(it => {
        this.model = it;
      }).catch(this.setError);
    },
    del() {
      const { model } = this;
      if (!model) {
        return;
      }
      this.startSaving();
      this.$store.api.deleteSubscription({
        customer_id: model.customer_id,
        product_id: model.product_id
      }).then(() => {
        this.$store.change();
        this.dialog = false;
      }).catch(this.setError).then(this.stopSaving);
    }
  }
});
